import { Tooltip as ReactTooltip } from 'react-tooltip';
import styled from 'styled-components';

interface TooltipContainerProps {
  textColor?: string;
  backgroundColor?: string;
}

export const TooltipContainer = styled(
  ReactTooltip,
).attrs<TooltipContainerProps>(({ textColor, backgroundColor }) => ({
  style: {
    backgroundColor: backgroundColor || undefined,
    color: textColor || undefined,
    padding: '8px',
  },
}))<TooltipContainerProps>`
  font-size: 13px !important; // default of react-tooltip v4

  /* Use filter drop-shadow instead of box-shadow to include the arrow */
  filter: drop-shadow(
    0 0 2px ${({ theme }) => theme.configs.tertiaryBox.secondaryFontColor}
  ) !important;

  /* Force color on all child elements */
  * {
    color: inherit !important;
  }

  /* Create transparent padding area for better hover accessibility */
  /* This creates an invisible hover zone around the tooltip content and arrow */
  &::before {
    content: '';
    position: absolute;
    inset: -10px; /* 10px transparent border around entire tooltip */
    pointer-events: auto; /* Ensures hover detection in this area */
    z-index: -1; /* Behind the tooltip content */
  }
`;
